module.exports = __webpack_public_path__ + "img/handshake.1850e91f.webp";